import React, { useContext, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Header from "../../components/Header";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Sidebar from "../../components/Sidebar";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Form from "react-bootstrap/Form";
import { GoDotFill, GoTrash } from "react-icons/go";
import Cloud from "../../Assets/Images/cloud.png";
import PdfImage from "../../Assets/Images/pdf.png";
import { FaCircleCheck } from "react-icons/fa6";
import "react-datepicker/dist/react-datepicker.css";
import { dateFormatter } from "../../utils/helper";
import { ProfileContext } from "../../context/ProfileContext";
import { BASE_URL, DELETE_LAB_RESULT, GET_LAB_RESULTS, UPLOAD_LAB_RESULTS } from "../../API";
import axios from "axios";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import { IoMdCloseCircle } from "react-icons/io";
import ReferralForm from "./ReferralForm";
import Loader from "../../components/Loader";

function ReferralManagementView() {
  const { headers, TOKEN } = useContext(ProfileContext)
  const { state } = useLocation();
  const referral = state?.referral;
  const fileInputRef = useRef(null);

  const [isLoading, setIsLoading] = useState(false);
  const [dragActive, setDragActive] = useState(false);
  const [labReport, setLabReport] = useState([]);
  const [showReportNameModal, setShowReportNameModal] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [reportName, setReportName] = useState("");

  const handleShowReportNameModal = () => setShowReportNameModal(true);
  const handleCloseReportNameModal = () => {
    setShowReportNameModal(false);
    setSelectedFiles([]);
    setReportName("");
  };

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") { setDragActive(true) }
    else if (e.type === "dragleave") { setDragActive(false); }
  };

  // Handle drop event
  const handleDrop = (e, consultationId) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      handleFileUpload(Array.from(e.dataTransfer.files), consultationId);
      e.dataTransfer.clearData();
    }
  };
  const handleFileUpload = async (acceptedFiles) => {
    if (!acceptedFiles || acceptedFiles.length === 0) {
      toast.error("No files selected.");
      return;
    }

    const maxSizeMB = 5;
    const allowedTypes = ["application/pdf"];
    const errorMessage = "Only PDF files under 5MB are allowed.";

    const invalidFiles = acceptedFiles.filter((file) => !allowedTypes.includes(file.type) || file.size > maxSizeMB * 1024 * 1024);

    if (invalidFiles.length > 0) {
      toast.error(errorMessage);
      return;
    }

    setSelectedFiles(acceptedFiles);
    handleShowReportNameModal();
  };
  const handleFileChange = (event, consultationId) => {
    const files = Array.from(event.target.files);
    handleFileUpload(files, consultationId);
  };
  const handleDeleteReport = async (id) => {
    setIsLoading(true);
    try {
      const response = await axios.delete(`${BASE_URL}${DELETE_LAB_RESULT}?_id=${id}`, { headers });
      const json = response.data;
      if (json.code === 200 && json.status === true) {
        toast.success('Report Delete Successful');
        getLabResults(referral?.id)
      }
      else { console.log("Error deleting user"); }
    } catch (err) { console.error('Error deleting user:', err); }
    finally { setIsLoading(false); }
  };
  const handleReportNameSubmit = async () => {
    if (!reportName.trim()) { toast.error("Please enter a report name."); return }
    if (!referral?._id) { toast.error("Missing patient or consultation information."); return }

    setIsLoading(true);

    try {
      const formData = new FormData();
      selectedFiles.forEach((file) => formData.append("file", file));
      formData.append("user_id", referral?.userData?._id);
      formData.append("report_name", reportName);
      formData.append("consultation_id", referral?._id)

      const headers = { "Content-Type": "multipart/form-data", token: TOKEN };
      const response = await axios.post(`${BASE_URL}${UPLOAD_LAB_RESULTS}`, formData, { headers });

      if (response.data.code === 200 && response.data.status === true) {
        setUploadedFiles((prev) => [
          ...prev,
          ...selectedFiles.map((file) => ({
            file,
            name: reportName,
            size: file.size,
            status: "Completed",
            url: response.data.data,
            consultationId: referral?._id,
          })),
        ]);
        if (fileInputRef.current) { fileInputRef.current.value = null }
        toast.success("PDF uploaded successfully!");
        getLabResults(referral?._id)
        handleCloseReportNameModal();
      }
      else { toast.error("Upload failed. Please try again.") }
    }
    catch (error) {
      const errorMessage = error.response?.data?.error_description || "An error occurred during upload.";
      toast.error(errorMessage);
    }
    finally {
      setIsLoading(false);
      handleCloseReportNameModal();
    }
  };
  const getLabResults = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}${GET_LAB_RESULTS}?consultation_id=${referral._id}&user_id=${referral.userData?._id}`, { headers });
      const json = response.data;
      if (json.code === 200 && json.status === true) { setLabReport(json.data) }
      else { console.log("Error fetching products") }
    }
    catch (err) { console.error("Best season product fetch error:", err); }
    finally { setIsLoading(false) }
  };

  return (
    <>
      <Loader isLoading={isLoading} />
      <div className="container-fluid">
        <Header />
        <div className="row">
          <Sidebar />
          <div className="col-9 main-dash-left">
            <section className="back-dashboard-sec comn-dashboard-page">
              <div className="cstm_bredcrumb_outer">
                <Breadcrumb className="cstm_bredcrumb" listProps={{ className: "breadcrumb-custom-separator" }}>
                  <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/referral-management" }}>Patient Record Management</Breadcrumb.Item>
                  <Breadcrumb.Item active >View Details</Breadcrumb.Item>
                </Breadcrumb>
              </div>
              <div className="notifi-list d-flex">
                <h6 className="comm_page_heading">Patient Records</h6>
              </div>
              <Row className="row-gap-5">
                <Col lg={8}>
                  <h5 className="comm_inner_sub_heading"> Medical History: </h5>
                  <div className="patient_record_left_outer">
                    <div className="comm_border_box">
                      <div className="pat_record_histoy_inn_row">
                        <div className="pat_record_histoy_inn_col">
                          <h6>chief complaints:</h6>
                          <p>{referral?.diagnostic_data?.chiefComplaint}</p>
                        </div>
                        <div className="pat_record_histoy_inn_col">
                          <h6>present medical history:</h6>
                          <p>{referral?.diagnostic_data?.currentMedicalHistory}</p>
                        </div>
                        {/* <div className="pat_record_histoy_inn_col">
                          <h6>past medical history:</h6>
                          <p>
                            The patient has a history of hypertension, diabetes,
                            coronary artery disease, or other relevant
                            conditions, with prior stent placement, CABG, or
                            cardiac interventions. They also have GERD, asthma,
                            COPD, or musculoskeletal issues, which may
                            contribute to symptoms. Current medications include
                            antihypertensives, statins, anticoagulants, with
                            good compliance. No known history of stroke,
                            pulmonary embolism, or major adverse drug reactions.
                          </p>
                        </div> */}
                      </div>
                    </div>
                    <div className="comm_border_box">
                      <div className="d-flex patient_rcrd_inn_row medical_diagnos_outer">
                        <div className="d-flex align-items-center medical_diagnos_row">
                          <h5 className="comm_inner_sub_heading mb-0">
                            {" "}medical diagnosis:{" "}
                          </h5>
                          <p className="mb-0">{referral?.diagnostic_data?.medicalDiagnosis}</p>
                        </div>
                      </div>
                    </div>
                    <div className="comm_border_box">
                      <div className="d-flex patient_rcrd_inn_row follow_remind_outer">
                        <h5 className="comm_inner_sub_heading mb-0">
                          Follow up reminders:
                        </h5>
                      </div>
                      <p>{referral?.diagnostic_data?.followUps}</p>
                    </div>
                  </div>
                </Col>
                <Col lg={4}>
                  <div className="comm_row_space_outer">
                    <div>
                      <h5 className="comm_inner_sub_heading">
                        Patient Details:
                      </h5>
                      <div className="patient-detail-outer">
                        <div className="patient-anme-view">
                          <h5>patient ID:</h5>
                          <p>#{referral?.userData?.patient_id}</p>
                        </div>
                        <div className="patient-anme-view">
                          <h5>patient name:</h5>
                          <p>{referral?.userData?.full_name}</p>
                        </div>
                        <div className="patient-anme-view">
                          <h5>Phone Number:</h5>
                          <p>{referral?.userData?.number}</p>
                        </div>
                        <div className="patient-anme-view">
                          <h5>Email:</h5>
                          <p>{referral?.userData?.email}</p>
                        </div>

                        <div className="patient-anme-view">
                          <h5>date of consultation:</h5>
                          <p>{dateFormatter(referral?.createdAt)}</p>
                        </div>
                        <div className="patient-anme-view">
                          <h5>age:</h5>
                          <p>{referral?.age}</p>
                        </div>
                        <div className="patient-anme-view">
                          <h5>Gender:</h5>
                          <p>{referral?.gender}</p>
                        </div>

                        <div className="patient-anme-view">
                          <h5>Condition:</h5>
                          <p>{referral?.condition}</p>
                        </div>
                        <div className="patient-anme-view">
                          <h5>status:</h5>
                          <div className="pending-status">
                            <GoDotFill /> Pending
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="comm_border_box">
                      <h5 className="comm_inner_sub_heading">Lab Results:</h5>
                      <div className={`file-upload-wrapper ${dragActive ? "drag-active" : ""}`}
                        onDragEnter={handleDrag}
                        onDragOver={handleDrag}
                        onDragLeave={handleDrag}
                        onDrop={(e) => handleDrop(e, referral?._id)}
                      >
                        <label className="file-upload-box mb-0">
                          <input
                            type="file"
                            className="file-upload-input"
                            accept="application/pdf"
                            ref={fileInputRef}
                            onChange={(e) => handleFileChange(e, referral?._id)} />
                          <div className="d-flex upload-content">
                            <figure className="cloud_img">
                              <img src={Cloud} alt="img" className="img-fluid" />
                            </figure>
                            <div className="drg-rw">
                              <h5> Choose a file or drag & drop it here </h5>
                              <p className="mb-0">PDF formats, up to 50MB</p>
                            </div>
                          </div>
                        </label>
                      </div>


                      {labReport && labReport.length > 0 ?
                        labReport.map((report, ID) => {
                          return (
                            <div className="pdf_record_row" key={ID}>
                              <div className="pdf_record_row_inner">
                                <figure><img src={PdfImage} alt="img" className="img-fluid" /></figure>
                                <div className="pdf-cntnt">
                                  <h5>{report?.report_name}</h5>
                                  <div className="d-fBack to worklex pdf_size_row"><FaCircleCheck /><span>Completed</span></div>
                                </div>
                              </div>
                              <div onClick={() => handleDeleteReport(report?._id)}><GoTrash className="trash" /></div>
                            </div>
                          )
                        })
                        :
                        <div className="pdf_record_row">
                          <div className="pdf_record_row_inner">
                            <figure><img src={PdfImage} alt="img" className="img-fluid" /></figure>
                            <div className="pdf-cntnt d-flex align-items-center">
                              <h5>No report found</h5>
                            </div>
                          </div>
                          <div></div>
                        </div>
                      }
                    </div>
                  </div>
                </Col>
              </Row>
              <ReferralForm referral={referral} />
            </section>
          </div>
        </div>
      </div>

      <Modal show={showReportNameModal} onHide={handleCloseReportNameModal} centered className="comm_modal patient_record_modal">
        <Modal.Body className="p-0">
          <Modal.Header>
            <Modal.Title>Enter Report Name</Modal.Title>
            <IoMdCloseCircle onClick={handleCloseReportNameModal} />
          </Modal.Header>
          <div className="comm_inner_body_modal">
            <Form.Group className="comn-class-inputs mb-0">
              <Form.Label>Report Name</Form.Label>
              <Form.Control type="text" placeholder="Enter Report Name" value={reportName} onChange={(e) => setReportName(e.target.value)} />
            </Form.Group>
            <div className="modal_pair_btns">
              <button className="main-outline-btn" onClick={handleCloseReportNameModal}>Cancel</button>
              <button className="main-btn" onClick={handleReportNameSubmit} disabled={!reportName.trim()}>Save Report</button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default ReferralManagementView;
